export const isIos = (): boolean =>
  (/iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
  !(window as unknown as Record<string, unknown>)['MSStream'];
